import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import ArrowForwardOutlinedIcon from '@material-ui/icons/ArrowForwardOutlined';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import { getCustomerInfoAPI, getMasterUserDetailsAPI, floatRequestAPI } from '../../services/api';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import Notify from '../../components/notify';
import { formatMoney } from '../../helpers/currency';
import validateForm from './validateForm.helper';

const FloatRequest = () => {
  const [validationErrors, setValidationErrors] = useState({});
  const [customerInfo, setCustomerInfo] = useState({});
  const [masterUserDetails, setMasterUserDetails] = useState({});
  const [invoiceEmail, setInvoiceEmail] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [openSuccessNotify, setOpenSuccessNotify] = useState(false);
  const [errors, setErrors] = useState(true);
  const [additionalEmail, setAdditionalEmail] = useState('');
  const [requestAmount, setRequestAmount] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const history = useHistory();

  useEffect(() => {
    getCustomerInfo();
  }, []);

  useEffect(async () => {
    const handleWheel = (e) => {
      e.preventDefault();
    };

    const handleArrowKeys = (e) => {
      if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
        e.preventDefault();
      }
    };

    const numberInputs = document.querySelectorAll('input[type="number"]');

    numberInputs.forEach((input) => {
      input.addEventListener('wheel', handleWheel, { passive: false });
      input.addEventListener('keydown', handleArrowKeys, { passive: false });
    });

    return () => {
      numberInputs.forEach((input) => {
        input.removeEventListener('wheel', handleWheel);
        input.removeEventListener('keydown', handleArrowKeys);
      });
    };
  }, [isLoading]);

  const getCustomerInfo = async () => {
    try {
      const masterUserDetails = await getMasterUserDetailsAPI();
      setMasterUserDetails(masterUserDetails);
      setInvoiceEmail(masterUserDetails.email);
      const customerInfo = await getCustomerInfoAPI();
      setCustomerInfo(customerInfo);
      setIsLoading(false);
    } catch (err) {
      console.log('err :: ', err);
    }
  };

  const handleContinue = () => {
    const validate = validateForm({ requestAmount, invoiceEmail, additionalEmail });
    if (validate.hasError) {
      setValidationErrors(validate);
      return;
    }
    setOpenDialog(true);
  };

  const handleConfirm = async () => {
    try {
      await floatRequestAPI({ amount: requestAmount, invoiceEmail, additionalEmail });

      history.push({
        pathname: '/float-request-confirmed',
        state: { requestAmount, invoiceEmail, additionalEmail }
      });
    } catch (err) {
      const errors =
        err && Object.keys(err).length > 0
          ? err
          : { errormessage: 'Something Went Wrong !!!!' };
      setErrors(errors);
      setIsLoading(false);
      setOpenSuccessNotify(true);
    }
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  const availableBalance = customerInfo.floatdata.creditflag === '1'
    ? formatMoney(parseFloat(customerInfo.floatdata.balance) + parseFloat(customerInfo.floatdata.creditlimit))
    : formatMoney(customerInfo.floatdata.balance);

  return (
    <>
      <Navbar />
      <div className="min-h-full flex justify-center items-center bg-black text-white container">
        <div className="issue-card-container container">
          <div className="flex flex-col text-center">
            <h2>Request float invoice</h2>
          </div>
          <div className="bulk-card-body">
            <div className="form-container">
              <div className="flex field-container">
                <TextField
                  label="Customer Name"
                  name="username"
                  type="text"
                  inputProps={{ readOnly: true }}
                  value={customerInfo.customer[0].customer_name}
                />
              </div>
              <div className="flex field-container">
                <TextField label="Available Balance" inputProps={{ readOnly: true }} value={availableBalance} />
              </div>
              <div className="flex field-container">
                <TextField
                  error={validationErrors.requestAmount}
                  label="Float Invoice Request Amount"
                  type="number"
                  name="requestAmount"
                  onChange={(e) => setRequestAmount(e.target.value)}
                  helperText={validationErrors?.msg?.requestAmount || '*Is required.'}
                  InputProps={{ inputProps: { min: 0 } }}
                  value={requestAmount}
                />
              </div>
              <div className="flex field-container">
                <TextField
                  label="Invoice Email To"
                  value={invoiceEmail}
                  name="email"
                  type="text"
                  onChange={(e) => setInvoiceEmail(e.target.value)}
                  error={validationErrors.invoiceEmail}
                  helperText={validationErrors?.msg?.invoiceEmail || "*Is required."}
                />
              </div>
              <div className="flex field-container">
                <TextField
                  label="Additional Email (Optional)"
                  error={validationErrors.additionalEmail}
                  type="text"
                  value={additionalEmail}
                  onChange={(e) => setAdditionalEmail(e.target.value)}
                  helperText={validationErrors?.msg?.additionalEmail} />
              </div>
            </div>
            <div className="action-footer" style={{ justifyContent: 'flex-end' }}>
              <Button variant="outlined" onClick={handleContinue} endIcon={<ArrowForwardOutlinedIcon style={{ color: '#FFFB00' }} />}>
                Continue
              </Button>
            </div>
          </div>
        </div>
      </div>
      <Footer />

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title dialog-title">Confirm</DialogTitle>
        <DialogContent style={{ display: 'flex', justifyContent: 'center' }}>
          <DialogContentText style={{ textAlign: 'left'/*, fontSize: '16px' */ }}>
            You are requesting for a Float Invoice of {formatMoney(requestAmount)} to be emailed to:<br />
            {invoiceEmail}<br />
            {additionalEmail && <>{additionalEmail} <br /></>}
            <br />
            If this is correct, please click Confirm to proceed or Back to amend.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className="dialog-action-btn"
            onClick={handleConfirm}
            color="primary"
          >
            Confirm
          </Button>
          <Button
            className="dialog-action-btn"
            onClick={() => setOpenDialog(false)}
            color="primary"
            autoFocus
          >
            Back
          </Button>
        </DialogActions>
      </Dialog>
      <Notify
        open={openSuccessNotify}
        onClose={() => setOpenSuccessNotify(false)}
        errors={errors}
      />
    </>
  );
};

export default FloatRequest;
